import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router'
import Layout from '../../components/layout/Layout'
import { comments } from '../../helpers/consultas'
import ResponseRowQuestion from '../../components/asignaturas/ResponseRowQuestion'
import { Link } from 'react-router-dom'

const QuestionAsignaturaView = () => {
    const {email} = useSelector(state => state.perfil);
    const {idAsig,idTema,question} =  useParams();
    const [preguntas, setPreguntas] = useState()
    useEffect(() => {
        comments(email,idAsig,question+'?').then(data => {
          setPreguntas(data)
        })
        return () => { setPreguntas() }
      },[email,idAsig,question])
    return (
        <Layout>
            <h1 className='title'>{question+'?'}</h1>
            <div className='controls-return'>
                <Link 
                  to={`/asignatura/${idAsig}/${idTema}`}
                  className='fas fa-arrow-circle-left'
                > Regresar</Link>
            </div>
            <div className='container-tb-responsive'>
                <table className='tb-responsive'>
                    <thead>
                        <tr>
                            <th>Nomre</th>
                            <th>Email</th>
                            <th>Respuesta</th>
                            <th>Fecha</th>
                            <th>Nota</th>
                            <th colSpan='2'>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            preguntas !== undefined &&
                            preguntas.map((pregunta, index) => (
                                <ResponseRowQuestion
                                    key={index}
                                    pregunta={pregunta}
                                    emailDocente={email}
                                    idAsig={idAsig}
                                />
                            ))
                        }
                    </tbody>
                </table>
            </div>
        </Layout>
    )
}

export default QuestionAsignaturaView